import { render, staticRenderFns } from "./bandejaFilters.vue?vue&type=template&id=119def27"
import script from "./bandejaFilters.vue?vue&type=script&lang=js"
export * from "./bandejaFilters.vue?vue&type=script&lang=js"
import style0 from "./bandejaFilters.vue?vue&type=style&index=0&id=119def27&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports